import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ROUTES } from '@/lib/routes';
import { useAuth } from '@/hooks/useAuth';

/**
 * Route-level role gate. Looks up the current pathname in {@link ROUTES} and,
 * if the matching route declares a {@code requiredRole}, redirects to
 * {@code /live} when the user lacks it.
 *
 * <p>Belt-and-braces: the Spring Security filter on the backend already returns
 * 403 for guest hits on OPERATE APIs — this guard just means a guest typing
 * {@code /cost} into the address bar bounces straight to a page they can see,
 * instead of landing on a broken UI that crashes when its API call 403s.
 */
export function RequireRole() {
  const { role } = useAuth();
  const location = useLocation();

  const route = ROUTES.find((r) => r.path === location.pathname);
  if (route?.requiredRole && route.requiredRole !== role) {
    return <Navigate to="/live" replace />;
  }
  return <Outlet />;
}
